import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  SocialButton,
  SUPPORTED_ICONS,
} from '@hivebrite/design-system/SocialButton';

const SocialLinks = ({ links }) => {
  // Include only link with supported icons.
  const validLinks = links
    .map((linkModel) => linkModel.toJS())
    .filter(({ link_type: linkType }) =>
      Object.keys(SUPPORTED_ICONS).includes(linkType),
    );

  return (
    validLinks.length > 0 && (
      <List as="ul" aria-label={__('Social Links')}>
        {validLinks.map(({ id, link_type: linkType, url, title }) => (
          <Item key={id} as="li">
            <SocialButton type={linkType} url={url} title={title} />
          </Item>
        ))}
      </List>
    )
  );
};

export default SocialLinks;

const List = styled(Box).attrs({
  flexWrap: 'wrap',
  height: '100%',
  justifyContent: { _: 'flex-start', m: 'flex-end' },
  pt: { _: 0, m: 3 },
  pb: 4,
  mx: { _: 4, m: 0 },
  width: { _: 'auto', m: 152 },
  minWidth: { _: '0', m: 152 },
})``;

const Item = styled(Box).attrs({
  ml: { _: 0, m: 2 },
  mr: { _: 2, m: 0 },
  my: 1,
})``;
